import { type FC, type ReactNode } from 'react'

import { IconCheck } from '@redteclab/icons'

export interface UniqueSellingPoint {
  content: ReactNode
  id: string
}

interface UniqueSellingPointsProps {
  uniqueSellingPoints?: UniqueSellingPoint[]
}

export const LoginRegistrationUniqueSellingPoints: FC<
  UniqueSellingPointsProps
> = ({ uniqueSellingPoints }) => {
  return (
    <ul>
      {uniqueSellingPoints?.map((point) => (
        <li className="flex list-none place-items-center" key={point.id}>
          <IconCheck className="mr-2 size-8 shrink-0 grow-0" />
          {point.content}
        </li>
      ))}
    </ul>
  )
}
